import "./styles.less";
import usePropertyData from "src/hooks/propertyData/usePropertyData";

export function LocationTag({ hideAddress = false }) {
	const { listing } = usePropertyData();

	const localityName =
		listing?.locations?.locality?.[0]?.name || '';

	const neighbourhoodName =
		listing?.locations?.neighbourhood?.[0]?.name || '';

	const stateName =
		listing?.locations?.state?.[0]?.name || '';

	const fullLocation = [
		localityName || neighbourhoodName,
		stateName
	]
		.filter(Boolean)
		.join(', ');

	const fallbackAddress =
		!hideAddress &&
			listing?.showAddress &&
			listing?.address
			? listing.address
			: '';

	return (
		<span className="property-location-tag">
			<p
				style={{ margin: '0' }}
				className="body body-1 body-regular medium"
			>
				{fullLocation || fallbackAddress || ''}
			</p>
		</span>
	);
}